/**
 * ElevenLabs SDK bazen type:"error" ile error_event gövdesi olmadan mesaj yollar;
 * handleErrorEvent bunu okuyunca uygulama çöküyor. Güvenli sarmalayıcı.
 */
import { VoiceConversation } from '@elevenlabs/client';

function applyPatch() {
  const baseProto = Object.getPrototypeOf(VoiceConversation.prototype);
  if (!baseProto?.handleErrorEvent || baseProto.__mersoErrorPatchApplied) {
    return;
  }

  const original = baseProto.handleErrorEvent;
  baseProto.handleErrorEvent = function patchedHandleErrorEvent(event) {
    if (!event?.error_event) {
      const fallback =
        event?.message ||
        (typeof event === 'string' ? event : null) ||
        'Bağlantı kesildi veya geçici bir sunucu hatası oluştu.';
      try {
        this.onError(`Sunucu hatası: ${fallback}`, { rawEvent: event });
      } catch (e) {
        console.error('[merso] ElevenLabs error handler:', fallback, event, e);
      }
      return;
    }
    return original.call(this, event);
  };
  baseProto.__mersoErrorPatchApplied = true;
}

applyPatch();
